export default __webpack_public_path__ + "static/media/CHAT.7e18da2b.jpg";